




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LoadingButton extends Vue {
    @Prop(String) type!: string;
    @Prop(String) variant!: string;
    @Prop(Function) action!: () => Promise<any>;

    loading: boolean = false;
    hideText: boolean = false;

    callRegisteredAction() {
        this.loading = true;
        this.hideText = true;
        const func = this.action;
        const promise: Promise<any> = func();
        if (promise) {
            promise.then((successObject: any) => {
                this.loading = false;
                setTimeout(() => {
                    this.hideText = false;
                }, 400);

                if (!successObject) {
                    return;
                }

                if ("redirect" in successObject && typeof successObject.redirect === "string") {
                    this.$router.push(successObject.redirect);
                }

                if ("callback" in successObject && typeof successObject.callback === "function") {
                    successObject.callback();
                }
            }, (errorObject: any) => {
                this.loading = false;
                setTimeout(() => {
                    this.hideText = false;
                }, 400);

                //Test if we caught a platform error:
                if (errorObject instanceof Error) {
                    throw errorObject;
                }

                if (!errorObject) {
                    return;
                }

                if ("redirect" in errorObject && typeof errorObject.redirect === "string") {
                    this.$router.push(errorObject.redirect);
                }

                if ("callback" in errorObject && typeof errorObject.callback === "function") {
                    errorObject.callback();
                }
            });
        }
    }
}
